import 'datatables.net'
import 'datatables.net-bs4'
import 'datatables.net-buttons'
import 'datatables.net-buttons-bs4'
import 'datatables.net-responsive'
//import 'datatables.net-responsive-bs'
import 'datatables.net-fixedheader'
